import { useContext } from 'react';
import { FacetContext } from '../contexts/FacetContext';
import { type IFacetContextShape } from '../types/facetTypes';

// A custom hook allows us to test better.
export const useFacetContext = (): IFacetContextShape => useContext(FacetContext) as IFacetContextShape;

export default useFacetContext;
